export const blueTheme = `
html .dropdown-title:hover {
    color: #01a4e0
}

html .dropdown-option:hover label {
    color: #01a4e0
}

html .time-cell {
    color: #433560;
}

html .title-cell {
    color: #9da0b3;
}

html .page {
    background: linear-gradient(32deg, #5f498f, #00aae7);
}

html .dropdown-title {
    background: transparent;
}

html .custom-checkbox:checked+label::before {
    background-image: url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'%2301a4e0\' viewBox=\'0 0 8 8\'%3e%3cpath d=\'M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z\'/%3e%3c/svg%3e") !important;
}

html .dropdown-title i {
    color: #01a4e0
}

html .dropdown-options {
    border-color: #dddee3;
}

html .dropdown-option label {
    border: 0;
    color: #9da0b3;
}

html .dropdown-option label .fa {
    color: white;
}

html .dropdown-option label:hover {}

html .dropdown-option input:checked+label {
    background: transparent;
    color: #01a4e0;
}

html .dropdown-option input:checked+label:hover {}

html .select-date-start {
    color: #1A1A18;
}

html input.date-week-picker:hover~.select-date-start {
    color: #01a4e0;
}

html .right-arrow__top,
html .right-arrow__bottom,
html .left-arrow__top,
html .left-arrow__bottom {
    background-color: #6A7075;
}

html .select-date-select {
    border-color: #C4C9D6;
}

html .right-arrow__label {
    color: #1A1A18;
}

html .right-arrow:hover .right-arrow__label {
    color: #01a4e0;
}

html .select-date-button {
    color: #1A1A18;
}

html .select-date-button:hover {
    color: #01a4e0;
}

html .headItem .marker {
    color: #9da0b3;
}

html .modal .cross__left,
html .modal .cross__right {
    background-color: #989BAF;
}

html .right-arrow:hover .right-arrow__top,
html .right-arrow:hover .right-arrow__bottom {
    background-color: #01a4e0;
}

html .left-arrow:hover .left-arrow__top,
html .left-arrow:hover .left-arrow__bottom {
    background-color: #01a4e0;
}

html .modal .modal-title {
    color: #433560;
}

html .modal .modal-name {
    color: #9DA0B3;
}

html .modal .modal-value {
    color: #433560;
}

html .modal .modal-item {
    color: #000;
}

html .form-item_validation-error {
    color: #d62445;
}

@media (max-width: 768px) {
    html .active .title-cell {
        color: #9da0b3;
    }

    html .active {
        background: #e7ecf2;
    }
}

@media (min-width: 801px) {
    html .form-item_input {
        border-bottom-color: #01a4e0;
    }

    html .form-item_input::-webkit-input-placeholder {
        color: #000;
    }

    html .form-item_input::-moz-placeholder {
        color: #000;
    }

    html .form-item_input:-moz-placeholder {
        color: #000;
    }

    html .form-item_input:-ms-input-placeholder {
        color: #000;
    }
}

@media (max-width: 800px) {
    html .modal .modal-item {
        color: #9da0b3;
        background: white;
    }

    html .form-item_input {
        border-bottom-color: white;
    }

    html .modal .modal-title {
        color: #433560;
    }

    html .modal .modal-name {
        color: #9DA0B3;
    }

    html .modal .modal-value {
        color: #433560;
    }
}`;
